import axios from 'axios';

const NON_RETRYABLE_READ_STATUS_CODES = new Set([400, 401, 403, 404, 422]);

export function isRetryableReadHttpStatus(status: number) {
  if (NON_RETRYABLE_READ_STATUS_CODES.has(status)) {
    return false;
  }

  return status === 408 || status === 429 || status >= 500;
}

export function isRetryableReadAxiosError(error: unknown) {
  if (!axios.isAxiosError(error)) {
    return false;
  }

  const status = error.response?.status;
  if (status === undefined) {
    return true;
  }

  return isRetryableReadHttpStatus(status);
}

export function getHttpErrorMessage(error: unknown) {
  if (!axios.isAxiosError(error)) {
    return error instanceof Error ? error.message : String(error);
  }

  const data = error.response?.data;
  const dataMessage = getApiErrorDataMessage(data);
  if (dataMessage) {
    return dataMessage;
  }

  return error.message;
}

function getApiErrorDataMessage(data: unknown): string | null {
  if (typeof data === 'string') {
    return data;
  }
  if (Array.isArray(data)) {
    const messages = data.map(getApiErrorDataMessage).filter(Boolean);
    return messages.length > 0 ? messages.join('\n') : null;
  }
  if (data && typeof data === 'object') {
    if ('detail' in data && data.detail) return getApiErrorDataMessage(data.detail);
    if ('message' in data && data.message) return getApiErrorDataMessage(data.message);
    if ('msg' in data && data.msg) return getApiErrorDataMessage(data.msg);
    if ('error' in data && data.error) return getApiErrorDataMessage(data.error);
  }
  return null;
}
